export const VALID_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
